import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { DocumentItem } from '@webplatform/frontkit/dist/types';

interface Props {
  items?: DocumentItem[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductUserHelpVideos',
  props: {
    items: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { items: DocumentItem[] };



const videoItems = computed(
  () => props.items?.filter((item) => item.file) ?? [],
);

return { __sfc: true,props, videoItems }
}

})